import BvBadge from 'volta/components/bv-badge';
import BvIcon from 'volta/components/bv-icon';
import BvTooltip from 'volta/components/bv-tooltip';
import BaseCell from './base-cell';

import type { TemplateOnlyComponent } from '@ember/component/template-only';

interface CellLabelCellSignature {
  Args: {
    cell: unknown;
    column: unknown;
    row: unknown;
    scrollToRow: unknown;
  };
}

const CellLabelCellComponent = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <BaseCell
    @cell={{@cell}}
    @row={{@row}}
    @column={{@column}}
    @scrollToRow={{@scrollToRow}}
    class='label-cell'
    as |baseCell|
  >
    {{#if baseCell.value.label}}
      <BvBadge
        @color={{baseCell.value.color}}
        @onClick={{baseCell.value.onClick}}
        class={{baseCell.value.className}}
      >
        {{#if baseCell.value.iconLeft}}
          <BvIcon @glyph={{baseCell.value.iconLeft}} @size='sm' class='u-mr-1' />
        {{/if}}
        {{baseCell.value.label}}
        {{#if baseCell.value.iconRight}}
          <BvIcon @glyph={{baseCell.value.iconRight}} @size='sm' class='u-ml-1' />
        {{/if}}
        {{#if baseCell.value.tooltipText}}
          <BvTooltip @text={{baseCell.value.tooltipText}} @side={{baseCell.value.tooltipSide}} />
        {{/if}}
      </BvBadge>
    {{/if}}
  </BaseCell>
</template> satisfies TemplateOnlyComponent<CellLabelCellSignature>;

export default CellLabelCellComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Cell::LabelCell': typeof CellLabelCellComponent;
    'cell/label-cell': typeof CellLabelCellComponent;
  }
}
